import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${setHoursEndOfDate(params.FechaHasta)}`);
  params.Estado &&
    params.Estado.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.Estado.Codigo}`);
  params.CodigoUsuarioCreacion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsuarioCreacion=${params.CodigoUsuarioCreacion}`);
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}Cliente=${params.Cliente}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.FechaEstadoDesde &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoDesde=${params.FechaEstadoDesde}`);
  params.FechaEstadoHasta &&
    (path = `${path !== '' ? `${path}&` : ''}FechaEstadoHasta=${setHoursEndOfDate(params.FechaEstadoHasta)}`);
  params.CodigoEspecificacionTecnica &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEspecificacionTecnica=${params.CodigoEspecificacionTecnica}`);

  if (params.ElementoTipo && Array.isArray(params.ElementoTipo)) {
    const codigosElementoTipo = params.ElementoTipo.map((tipo) => tipo.Codigo);
    codigosElementoTipo.forEach((codigo) => {
      path = `${path !== '' ? `${path}&` : ''}CodigoElementoTipo=${encodeURIComponent(codigo)}`;
    });
  }
  params.CodigoEquivalente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEquivalente=${params.CodigoEquivalente}`);
  params.CodigoAdicional &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoAdicional=${params.CodigoAdicional}`);
  params.DescripcionComercial &&
    (path = `${path !== '' ? `${path}&` : ''}DescripcionComercial=${encodeURIComponent(params.DescripcionComercial)}`);
  params.Suaje &&
    (path = `${path !== '' ? `${path}&` : ''}Suaje=${encodeURIComponent(params.Suaje)}`);
  params.CodigoUsabilidad &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsabilidad=${params.CodigoUsabilidad}`);
  params.CodigoOrdenProduccion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoOrdenProduccion=${encodeURIComponent(params.CodigoOrdenProduccion)}`);
  if (params.Procesos && Array.isArray(params.Procesos) && params.Procesos.length > 0) {
    const codigosProcesos = params.Procesos.map((p) => p.Codigo || p);
    const stringProcesos = codigosProcesos.join(',');
    path = `${path !== '' ? `${path}&` : ''}Procesos=${encodeURIComponent(stringProcesos)}`;
  }
  return path;
};

const setHoursEndOfDate = (fecha) => {
  if (fecha) {
    const fechaSeleccionada = new Date(fecha);
    // Establece la fecha seleccionada al final del día
    fechaSeleccionada.setHours(23, 59, 59, 999);
    return fechaSeleccionada;
  }
  return fecha;
};
